import { render, staticRenderFns } from "./distancerun.vue?vue&type=template&id=0c8a0c78"
import script from "./distancerun.vue?vue&type=script&lang=js"
export * from "./distancerun.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports